module.exports = __webpack_public_path__ + "img/finalize-report-active.c04fdc8f.svg";